// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ele-upload-video_mask__item{padding:0 10px}.ele-upload-video .el-upload__tip{line-height:12px}", ""]);
// Exports
module.exports = exports;
